<template>
  <div class="tree-default">
    <vue-okr-tree 
      ref="tree" 
      :label-height="30"
      :render-content="renderContent"
      node-key="id"
      :data="tree">
    </vue-okr-tree> 
  </div>
</template>

<script>
import {VueOkrTree} from 'vue-okr-tree';
import 'vue-okr-tree/dist/vue-okr-tree.css'
export default {
  props:["tree"],
  components:{
    VueOkrTree
  },
  data(){
    return{
    }
  },
  methods:{
    //自定义树节点
    renderContent (h, node) {
      return (
        <div class='name'>
          <p>{node.data.stationName}</p>
        </div>
      )
    },
  }
}
</script>
<style lang='less'>
.tree-default{ margin-top:20px;
  .name{ 
    font-size:.68rem ; 
    color: #ccd0f2; 
    border:#ccd0f2 solid 1px; 
    border-radius: 4px; 
    padding:4px 12px 6px;
  }
  .org-chart-node-label-inner{ height: 39px !important; padding:0 10px !important}
  .org-chart-container{ width: max-content;}
}
</style>